// making.api.ts

import { db } from "../../firebase/firebaseConfig";
import { Collections, MakingRequest, Status } from "../../types/type";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  runTransaction,
  deleteDoc,
  getDoc,
} from "firebase/firestore";

// Making 컬렉션에서 모든 요청을 가져오는 함수
export const fetchMakingRequestList = async (): Promise<MakingRequest[]> => {
  try {
    const makingCollection = collection(db, Collections.MAKING_REQUEST);
    const snapshot = await getDocs(makingCollection);
    const makingRequests = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        songRequestId: doc.id, // 도큐먼트 ID를 songRequestId로 사용
      } as MakingRequest;
    });
    return makingRequests;
  } catch (error) {
    console.error("Error fetching making requests:", error);
    throw error;
  }
};

// 특정 Making 요청을 업데이트하는 함수
export const updateMakingRequest = async (
  id: string,
  updatedData: Partial<MakingRequest>
) => {
  try {
    const docRef = doc(db, Collections.MAKING_REQUEST, id);
    await updateDoc(docRef, updatedData);
  } catch (error) {
    console.error("Error updating making request:", error);
    throw error;
  }
};

export const deleteMakingRequest = async (makingRequest: MakingRequest) => {
  try {
    const docRef = doc(
      db,
      Collections.MAKING_REQUEST,
      makingRequest.songRequestId
    );
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error updating making request:", error);
    throw error;
  }
};

export const updateSongRequestToFail = async ({
  songRequestId,
  userId,
}: {
  songRequestId: string;
  userId: string;
}) => {
  const songRequestRef = doc(db, Collections.SONG_REQUEST, songRequestId);
  const userRef = doc(db, Collections.USER, userId);

  await updateDoc(songRequestRef, {
    status: Status.FAILED,
  });

  const userDoc = await getDoc(userRef);
  if (userDoc.exists()) {
    const userData = userDoc.data();
    const updatedSongRequestList = userData.songRequestList.map(
      (request: any) => {
        if (request.songRequestId === songRequestId) {
          return { ...request, status: Status.FAILED };
        }
        return request;
      }
    );

    await updateDoc(userRef, { songRequestList: updatedSongRequestList });
    console.log(`Updated user songRequestList for user ID: ${userId}`);
  } else {
    console.error(`User document with ID ${userId} does not exist`);
  }
};
